import { render } from "./NewsSection.vue?vue&type=template&id=c4ebcdfa&scoped=true"
import script from "./NewsSection.vue?vue&type=script&lang=js"
export * from "./NewsSection.vue?vue&type=script&lang=js"

import "@/assets/styles/newssections.css?vue&type=style&index=0&id=c4ebcdfa&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ebcdfa"]])

export default __exports__